import styled from 'styled-components';
import { variant } from 'styled-system';

import colors from '../../assets/theme/colors';

import { ColorVariant } from './types';

interface StylesButtonProps {
  fullWidth?: boolean;
  colorVariant?: ColorVariant;
  buttonMargin?: boolean;
  colorIcon?: boolean;
  disabled?: boolean;
}

interface FirstLetterCapital {
  paddingRight?: boolean;
}

export const StylesButton = styled('button')<StylesButtonProps>(
  (props) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: props.fullWidth ? '100%' : 'none',
    padding: '13px 20px',
    fontWeight: '700',
    fontSize: '20px',
    textAlign: 'center',
    color: '#051224',
    opacity: props.disabled ? '0.6' : '1',
    background: props.colorVariant
      ? `${colors.secButtonColor}`
      : `${colors.buttonColor}`,
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    userSelect: 'none',
    // maxWidth: '192px',
    margin: '0 auto',
    marginBottom: props.buttonMargin ? '17px' : 'none',
    'svg path': {
      stroke: props.colorIcon ? '#262626' : '',
      fill: props.colorIcon ? '#262626' : '',
    },
  }),
  variant({
    prop: 'colorVariant',
    variants: {
      black: {
        bg: '#262626',
        borderRadius: '6px',
        color: '#FFFFFF',
      },
      yellow: {
        bg: '#E4F53B',
        borderRadius: '8px',
        color: '#051224',
      },
      green: {
        bg: `${colors.secButtonColor}`,
        borderRadius: '6px',
        color: '#051224',
      },
      transparent: {
        bg: 'transparent',
        borderRadius: '6px',
        color: '#E4F53B',
        border: '1px solid #E4F53B',
      },
      red: {
        bg: '#E4002B',
        borderRadius: '6px',
        color: '#FFFFFF',
      },
      blue: {
        bg: 'transparent',
        borderRadius: '6px',
        color: '#0FB592',
        border: '1px solid #0FB592',
      },
      notStyles: {
        background: 'none',
        height: 'max-content',
        border: 'none',
        padding: '15px',
        borderRadius: 'none',
        position: 'absolute',
        right: '0px',
        top: '50%',
        transform: 'translate(0, -50%)',
      },
    },
  }),
);
export const FirstLetterCapital = styled('div')<FirstLetterCapital>(
  (props) => ({
    paddingRight: props.paddingRight ? '10px' : '8px',
    ':first-letter': {
      textTransform: 'uppercase',
    },
  }),
);
